import { render, staticRenderFns } from "./GuestTalk.vue?vue&type=template&id=77c91cdc&scoped=true&"
import script from "./GuestTalk.vue?vue&type=script&lang=js&"
export * from "./GuestTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c91cdc",
  null
  
)

export default component.exports